import { faChalkboardTeacher, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import ForumCourseList from '../../../Components/ForumCourseList/ForumCourseList'
import Style from './LandingForum.module.css'
import ReactLoading from 'react-loading';
import { ForumCourseAPI } from '../../../Api/ClientServices'

 const LandingForum = () => {
    const history=useHistory()
    const[course,setCourse]=useState()
    useEffect(()=>{
        getUserInfo()
    },[])
    const getUserInfo=async()=>{
        const data=await ForumCourseAPI()
        setCourse(data.course)
    }
    let loadingHandler=null
    if(course===undefined){
        loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
        <ReactLoading type={'cylon'} color={'#096CCC'} />
      </div>
    }
    else if(course.length===0){
        loadingHandler=<p className='w-100 p-2 alert alert-warning mt-3 text-center'>شما دوره ای نخریده اید</p>
    }
    else{
        loadingHandler=course.map(item=>{
            return(
                <ForumCourseList key={item.id} item={item}/>
            )
        })
    }
    return (
        <div className={`pageHolder ${Style.PageLandingForum}`}>
            <div className={Style.TopForum}>
                <FontAwesomeIcon icon={faChevronRight} className={Style.BackHolder} onClick={() => history.goBack()}/>
                <img src="/Assets/Images/Forum/bg.png" alt="electronic" />
                <div className={Style.TextHolder}>
                    <img src="/Assets/Images/Regular/Logo.png" alt="logo" />
                    <p>به انجمن گام به گام با الکترونیک خوش آمدید</p>
                </div>
            </div>
            <section className={Style.CoursesPartHolder}>
                <div className={Style.DivisonCourse}>
                    <h3><FontAwesomeIcon icon={faChalkboardTeacher}/> دوره مورد نظر خودرا انتخاب کنید</h3>
                    <div className={Style.CourseListHolder}>
                        {
                            loadingHandler
                        }
                    </div>
                </div>
            </section>
        </div>
    )
}
export default LandingForum
